import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ShGenericMethodHttpService {
  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  shGenericGetMethod(
    request: FrameIn,
    url: string,
    envHeaders: any,
    flowUser?: string
  ): Observable<FrameOutResponse> {
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers: this._shSharedHeaders.buildHeaders(
        request,
        envHeaders,
        flowUser
      ),
    });
  }

  shGenericGetMethodID(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    let headers = this._shSharedHeaders.buildHeaders(request, envHeaders);
    headers = headers.set('id', '1');
    return this.http.get<FrameOutResponse>(`${url}`, {
      headers,
    });
  }

  shGenericPostMethod(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  shGenericPutMethod(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.put<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }

  shGMGenericGetMethod(url: string): Observable<any> {
    return this.http.get<any>(`${url}`, {});
  }
}
